/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StocksRouteRouteImport } from './routes/stocks/route'
import { Route as ReportsRouteRouteImport } from './routes/reports/route'
import { Route as ProductionRouteRouteImport } from './routes/production/route'
import { Route as PatientDashboardRouteRouteImport } from './routes/patient-dashboard/route'
import { Route as ConfigurationRouteRouteImport } from './routes/configuration/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as ActivityRouteRouteImport } from './routes/activity/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ReportsIndexRouteImport } from './routes/reports/index'
import { Route as ProductionIndexRouteImport } from './routes/production/index'
import { Route as CleanroomIndexRouteImport } from './routes/cleanroom/index'
import { Route as ActivityIndexRouteImport } from './routes/activity/index'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthPasswordSetupRouteImport } from './routes/auth/password-setup'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as StocksReturnsIndexRouteImport } from './routes/stocks/returns/index'
import { Route as StocksRestVialsIndexRouteImport } from './routes/stocks/rest-vials/index'
import { Route as StocksDiscardsIndexRouteImport } from './routes/stocks/discards/index'
import { Route as StocksBatchesIndexRouteImport } from './routes/stocks/batches/index'
import { Route as PatientDashboardPatientsIndexRouteImport } from './routes/patient-dashboard/patients/index'
import { Route as ConfigurationWardsIndexRouteImport } from './routes/configuration/wards/index'
import { Route as ConfigurationUsersIndexRouteImport } from './routes/configuration/users/index'
import { Route as ConfigurationUserGroupsIndexRouteImport } from './routes/configuration/user-groups/index'
import { Route as ConfigurationSystemLogsIndexRouteImport } from './routes/configuration/system-logs/index'
import { Route as ConfigurationSmartCompoundersIndexRouteImport } from './routes/configuration/smart-compounders/index'
import { Route as ConfigurationSettingsIndexRouteImport } from './routes/configuration/settings/index'
import { Route as ConfigurationSectionsIndexRouteImport } from './routes/configuration/sections/index'
import { Route as ConfigurationProtocolsIndexRouteImport } from './routes/configuration/protocols/index'
import { Route as ConfigurationPharmaciesIndexRouteImport } from './routes/configuration/pharmacies/index'
import { Route as ConfigurationLocationsIndexRouteImport } from './routes/configuration/locations/index'
import { Route as ConfigurationHl7IndexRouteImport } from './routes/configuration/hl7/index'
import { Route as ConfigurationCustomersIndexRouteImport } from './routes/configuration/customers/index'
import { Route as StocksBatchesNewRouteImport } from './routes/stocks/batches/new'
import { Route as PatientDashboardPatientsNewRouteImport } from './routes/patient-dashboard/patients/new'
import { Route as PatientDashboardPatientsPatientIdRouteImport } from './routes/patient-dashboard/patients/$patientId'
import { Route as ConfigurationWardsNewRouteImport } from './routes/configuration/wards/new'
import { Route as ConfigurationUsersNewRouteImport } from './routes/configuration/users/new'
import { Route as ConfigurationUserGroupsNewRouteImport } from './routes/configuration/user-groups/new'
import { Route as ConfigurationSmartCompoundersOrdersRouteImport } from './routes/configuration/smart-compounders/orders'
import { Route as ConfigurationSmartCompoundersMappingsRouteImport } from './routes/configuration/smart-compounders/mappings'
import { Route as ConfigurationSectionsNewRouteImport } from './routes/configuration/sections/new'
import { Route as ConfigurationProtocolsNewRouteImport } from './routes/configuration/protocols/new'
import { Route as ConfigurationPharmaciesNewRouteImport } from './routes/configuration/pharmacies/new'
import { Route as ConfigurationLocationsNewRouteImport } from './routes/configuration/locations/new'
import { Route as ConfigurationCustomersNewRouteImport } from './routes/configuration/customers/new'
import { Route as ConfigurationBasicDataResourceRouteImport } from './routes/configuration/basic-data/$resource'
import { Route as ConfigurationProductsTradeNamesIndexRouteImport } from './routes/configuration/products/trade-names/index'
import { Route as ConfigurationProductsConsumablesIndexRouteImport } from './routes/configuration/products/consumables/index'
import { Route as ConfigurationProductsCompaniesIndexRouteImport } from './routes/configuration/products/companies/index'
import { Route as ConfigurationDrugCatalogSupportiveMedicationsIndexRouteImport } from './routes/configuration/drug-catalog/supportive-medications/index'
import { Route as ConfigurationDrugCatalogSolutionsIndexRouteImport } from './routes/configuration/drug-catalog/solutions/index'
import { Route as ConfigurationDrugCatalogActiveSubstancesIndexRouteImport } from './routes/configuration/drug-catalog/active-substances/index'
import { Route as ConfigurationBasicDataCategoriesIndexRouteImport } from './routes/configuration/basic-data/categories/index'
import { Route as ConfigurationProductsTradeNamesNewRouteImport } from './routes/configuration/products/trade-names/new'
import { Route as ConfigurationProductsConsumablesNewRouteImport } from './routes/configuration/products/consumables/new'
import { Route as ConfigurationProductsCompaniesNewRouteImport } from './routes/configuration/products/companies/new'
import { Route as ConfigurationDrugCatalogSupportiveMedicationsNewRouteImport } from './routes/configuration/drug-catalog/supportive-medications/new'
import { Route as ConfigurationDrugCatalogSolutionsNewRouteImport } from './routes/configuration/drug-catalog/solutions/new'
import { Route as ConfigurationDrugCatalogActiveSubstancesNewRouteImport } from './routes/configuration/drug-catalog/active-substances/new'
import { Route as ConfigurationBasicDataCategoriesNewRouteImport } from './routes/configuration/basic-data/categories/new'

const StocksRouteRoute = StocksRouteRouteImport.update({
  id: '/stocks',
  path: '/stocks',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRouteRoute = ReportsRouteRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductionRouteRoute = ProductionRouteRouteImport.update({
  id: '/production',
  path: '/production',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientDashboardRouteRoute = PatientDashboardRouteRouteImport.update({
  id: '/patient-dashboard',
  path: '/patient-dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigurationRouteRoute = ConfigurationRouteRouteImport.update({
  id: '/configuration',
  path: '/configuration',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRouteRoute = ActivityRouteRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ReportsRouteRoute,
} as any)
const ProductionIndexRoute = ProductionIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProductionRouteRoute,
} as any)
const CleanroomIndexRoute = CleanroomIndexRouteImport.update({
  id: '/cleanroom/',
  path: '/cleanroom/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityIndexRoute = ActivityIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ActivityRouteRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthPasswordSetupRoute = AuthPasswordSetupRouteImport.update({
  id: '/password-setup',
  path: '/password-setup',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const StocksReturnsIndexRoute = StocksReturnsIndexRouteImport.update({
  id: '/returns/',
  path: '/returns/',
  getParentRoute: () => StocksRouteRoute,
} as any)
const StocksRestVialsIndexRoute = StocksRestVialsIndexRouteImport.update({
  id: '/rest-vials/',
  path: '/rest-vials/',
  getParentRoute: () => StocksRouteRoute,
} as any)
const StocksDiscardsIndexRoute = StocksDiscardsIndexRouteImport.update({
  id: '/discards/',
  path: '/discards/',
  getParentRoute: () => StocksRouteRoute,
} as any)
const StocksBatchesIndexRoute = StocksBatchesIndexRouteImport.update({
  id: '/batches/',
  path: '/batches/',
  getParentRoute: () => StocksRouteRoute,
} as any)
const PatientDashboardPatientsIndexRoute =
  PatientDashboardPatientsIndexRouteImport.update({
    id: '/patients/',
    path: '/patients/',
    getParentRoute: () => PatientDashboardRouteRoute,
  } as any)
const ConfigurationWardsIndexRoute = ConfigurationWardsIndexRouteImport.update({
  id: '/wards/',
  path: '/wards/',
  getParentRoute: () => ConfigurationRouteRoute,
} as any)
const ConfigurationUsersIndexRoute = ConfigurationUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => ConfigurationRouteRoute,
} as any)
const ConfigurationUserGroupsIndexRoute =
  ConfigurationUserGroupsIndexRouteImport.update({
    id: '/user-groups/',
    path: '/user-groups/',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationSystemLogsIndexRoute =
  ConfigurationSystemLogsIndexRouteImport.update({
    id: '/system-logs/',
    path: '/system-logs/',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationSmartCompoundersIndexRoute =
  ConfigurationSmartCompoundersIndexRouteImport.update({
    id: '/smart-compounders/',
    path: '/smart-compounders/',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationSettingsIndexRoute =
  ConfigurationSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationSectionsIndexRoute =
  ConfigurationSectionsIndexRouteImport.update({
    id: '/sections/',
    path: '/sections/',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationProtocolsIndexRoute =
  ConfigurationProtocolsIndexRouteImport.update({
    id: '/protocols/',
    path: '/protocols/',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationPharmaciesIndexRoute =
  ConfigurationPharmaciesIndexRouteImport.update({
    id: '/pharmacies/',
    path: '/pharmacies/',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationLocationsIndexRoute =
  ConfigurationLocationsIndexRouteImport.update({
    id: '/locations/',
    path: '/locations/',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationHl7IndexRoute = ConfigurationHl7IndexRouteImport.update({
  id: '/hl7/',
  path: '/hl7/',
  getParentRoute: () => ConfigurationRouteRoute,
} as any)
const ConfigurationCustomersIndexRoute =
  ConfigurationCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const StocksBatchesNewRoute = StocksBatchesNewRouteImport.update({
  id: '/batches/new',
  path: '/batches/new',
  getParentRoute: () => StocksRouteRoute,
} as any)
const PatientDashboardPatientsNewRoute =
  PatientDashboardPatientsNewRouteImport.update({
    id: '/patients/new',
    path: '/patients/new',
    getParentRoute: () => PatientDashboardRouteRoute,
  } as any)
const PatientDashboardPatientsPatientIdRoute =
  PatientDashboardPatientsPatientIdRouteImport.update({
    id: '/patients/$patientId',
    path: '/patients/$patientId',
    getParentRoute: () => PatientDashboardRouteRoute,
  } as any)
const ConfigurationWardsNewRoute = ConfigurationWardsNewRouteImport.update({
  id: '/wards/new',
  path: '/wards/new',
  getParentRoute: () => ConfigurationRouteRoute,
} as any)
const ConfigurationUsersNewRoute = ConfigurationUsersNewRouteImport.update({
  id: '/users/new',
  path: '/users/new',
  getParentRoute: () => ConfigurationRouteRoute,
} as any)
const ConfigurationUserGroupsNewRoute =
  ConfigurationUserGroupsNewRouteImport.update({
    id: '/user-groups/new',
    path: '/user-groups/new',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationSmartCompoundersOrdersRoute =
  ConfigurationSmartCompoundersOrdersRouteImport.update({
    id: '/smart-compounders/orders',
    path: '/smart-compounders/orders',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationSmartCompoundersMappingsRoute =
  ConfigurationSmartCompoundersMappingsRouteImport.update({
    id: '/smart-compounders/mappings',
    path: '/smart-compounders/mappings',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationSectionsNewRoute =
  ConfigurationSectionsNewRouteImport.update({
    id: '/sections/new',
    path: '/sections/new',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationProtocolsNewRoute =
  ConfigurationProtocolsNewRouteImport.update({
    id: '/protocols/new',
    path: '/protocols/new',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationPharmaciesNewRoute =
  ConfigurationPharmaciesNewRouteImport.update({
    id: '/pharmacies/new',
    path: '/pharmacies/new',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationLocationsNewRoute =
  ConfigurationLocationsNewRouteImport.update({
    id: '/locations/new',
    path: '/locations/new',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationCustomersNewRoute =
  ConfigurationCustomersNewRouteImport.update({
    id: '/customers/new',
    path: '/customers/new',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationBasicDataResourceRoute =
  ConfigurationBasicDataResourceRouteImport.update({
    id: '/basic-data/$resource',
    path: '/basic-data/$resource',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationProductsTradeNamesIndexRoute =
  ConfigurationProductsTradeNamesIndexRouteImport.update({
    id: '/products/trade-names/',
    path: '/products/trade-names/',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationProductsConsumablesIndexRoute =
  ConfigurationProductsConsumablesIndexRouteImport.update({
    id: '/products/consumables/',
    path: '/products/consumables/',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationProductsCompaniesIndexRoute =
  ConfigurationProductsCompaniesIndexRouteImport.update({
    id: '/products/companies/',
    path: '/products/companies/',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationDrugCatalogSupportiveMedicationsIndexRoute =
  ConfigurationDrugCatalogSupportiveMedicationsIndexRouteImport.update({
    id: '/drug-catalog/supportive-medications/',
    path: '/drug-catalog/supportive-medications/',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationDrugCatalogSolutionsIndexRoute =
  ConfigurationDrugCatalogSolutionsIndexRouteImport.update({
    id: '/drug-catalog/solutions/',
    path: '/drug-catalog/solutions/',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationDrugCatalogActiveSubstancesIndexRoute =
  ConfigurationDrugCatalogActiveSubstancesIndexRouteImport.update({
    id: '/drug-catalog/active-substances/',
    path: '/drug-catalog/active-substances/',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationBasicDataCategoriesIndexRoute =
  ConfigurationBasicDataCategoriesIndexRouteImport.update({
    id: '/basic-data/categories/',
    path: '/basic-data/categories/',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationProductsTradeNamesNewRoute =
  ConfigurationProductsTradeNamesNewRouteImport.update({
    id: '/products/trade-names/new',
    path: '/products/trade-names/new',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationProductsConsumablesNewRoute =
  ConfigurationProductsConsumablesNewRouteImport.update({
    id: '/products/consumables/new',
    path: '/products/consumables/new',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationProductsCompaniesNewRoute =
  ConfigurationProductsCompaniesNewRouteImport.update({
    id: '/products/companies/new',
    path: '/products/companies/new',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationDrugCatalogSupportiveMedicationsNewRoute =
  ConfigurationDrugCatalogSupportiveMedicationsNewRouteImport.update({
    id: '/drug-catalog/supportive-medications/new',
    path: '/drug-catalog/supportive-medications/new',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationDrugCatalogSolutionsNewRoute =
  ConfigurationDrugCatalogSolutionsNewRouteImport.update({
    id: '/drug-catalog/solutions/new',
    path: '/drug-catalog/solutions/new',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationDrugCatalogActiveSubstancesNewRoute =
  ConfigurationDrugCatalogActiveSubstancesNewRouteImport.update({
    id: '/drug-catalog/active-substances/new',
    path: '/drug-catalog/active-substances/new',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)
const ConfigurationBasicDataCategoriesNewRoute =
  ConfigurationBasicDataCategoriesNewRouteImport.update({
    id: '/basic-data/categories/new',
    path: '/basic-data/categories/new',
    getParentRoute: () => ConfigurationRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/configuration': typeof ConfigurationRouteRouteWithChildren
  '/patient-dashboard': typeof PatientDashboardRouteRouteWithChildren
  '/production': typeof ProductionRouteRouteWithChildren
  '/reports': typeof ReportsRouteRouteWithChildren
  '/stocks': typeof StocksRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/auth/password-setup': typeof AuthPasswordSetupRoute
  '/auth/register': typeof AuthRegisterRoute
  '/activity/': typeof ActivityIndexRoute
  '/cleanroom/': typeof CleanroomIndexRoute
  '/production/': typeof ProductionIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/configuration/basic-data/$resource': typeof ConfigurationBasicDataResourceRoute
  '/configuration/customers/new': typeof ConfigurationCustomersNewRoute
  '/configuration/locations/new': typeof ConfigurationLocationsNewRoute
  '/configuration/pharmacies/new': typeof ConfigurationPharmaciesNewRoute
  '/configuration/protocols/new': typeof ConfigurationProtocolsNewRoute
  '/configuration/sections/new': typeof ConfigurationSectionsNewRoute
  '/configuration/smart-compounders/mappings': typeof ConfigurationSmartCompoundersMappingsRoute
  '/configuration/smart-compounders/orders': typeof ConfigurationSmartCompoundersOrdersRoute
  '/configuration/user-groups/new': typeof ConfigurationUserGroupsNewRoute
  '/configuration/users/new': typeof ConfigurationUsersNewRoute
  '/configuration/wards/new': typeof ConfigurationWardsNewRoute
  '/patient-dashboard/patients/$patientId': typeof PatientDashboardPatientsPatientIdRoute
  '/patient-dashboard/patients/new': typeof PatientDashboardPatientsNewRoute
  '/stocks/batches/new': typeof StocksBatchesNewRoute
  '/configuration/customers/': typeof ConfigurationCustomersIndexRoute
  '/configuration/hl7/': typeof ConfigurationHl7IndexRoute
  '/configuration/locations/': typeof ConfigurationLocationsIndexRoute
  '/configuration/pharmacies/': typeof ConfigurationPharmaciesIndexRoute
  '/configuration/protocols/': typeof ConfigurationProtocolsIndexRoute
  '/configuration/sections/': typeof ConfigurationSectionsIndexRoute
  '/configuration/settings/': typeof ConfigurationSettingsIndexRoute
  '/configuration/smart-compounders/': typeof ConfigurationSmartCompoundersIndexRoute
  '/configuration/system-logs/': typeof ConfigurationSystemLogsIndexRoute
  '/configuration/user-groups/': typeof ConfigurationUserGroupsIndexRoute
  '/configuration/users/': typeof ConfigurationUsersIndexRoute
  '/configuration/wards/': typeof ConfigurationWardsIndexRoute
  '/patient-dashboard/patients/': typeof PatientDashboardPatientsIndexRoute
  '/stocks/batches/': typeof StocksBatchesIndexRoute
  '/stocks/discards/': typeof StocksDiscardsIndexRoute
  '/stocks/rest-vials/': typeof StocksRestVialsIndexRoute
  '/stocks/returns/': typeof StocksReturnsIndexRoute
  '/configuration/basic-data/categories/new': typeof ConfigurationBasicDataCategoriesNewRoute
  '/configuration/drug-catalog/active-substances/new': typeof ConfigurationDrugCatalogActiveSubstancesNewRoute
  '/configuration/drug-catalog/solutions/new': typeof ConfigurationDrugCatalogSolutionsNewRoute
  '/configuration/drug-catalog/supportive-medications/new': typeof ConfigurationDrugCatalogSupportiveMedicationsNewRoute
  '/configuration/products/companies/new': typeof ConfigurationProductsCompaniesNewRoute
  '/configuration/products/consumables/new': typeof ConfigurationProductsConsumablesNewRoute
  '/configuration/products/trade-names/new': typeof ConfigurationProductsTradeNamesNewRoute
  '/configuration/basic-data/categories/': typeof ConfigurationBasicDataCategoriesIndexRoute
  '/configuration/drug-catalog/active-substances/': typeof ConfigurationDrugCatalogActiveSubstancesIndexRoute
  '/configuration/drug-catalog/solutions/': typeof ConfigurationDrugCatalogSolutionsIndexRoute
  '/configuration/drug-catalog/supportive-medications/': typeof ConfigurationDrugCatalogSupportiveMedicationsIndexRoute
  '/configuration/products/companies/': typeof ConfigurationProductsCompaniesIndexRoute
  '/configuration/products/consumables/': typeof ConfigurationProductsConsumablesIndexRoute
  '/configuration/products/trade-names/': typeof ConfigurationProductsTradeNamesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/configuration': typeof ConfigurationRouteRouteWithChildren
  '/patient-dashboard': typeof PatientDashboardRouteRouteWithChildren
  '/stocks': typeof StocksRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/auth/password-setup': typeof AuthPasswordSetupRoute
  '/auth/register': typeof AuthRegisterRoute
  '/activity': typeof ActivityIndexRoute
  '/cleanroom': typeof CleanroomIndexRoute
  '/production': typeof ProductionIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/configuration/basic-data/$resource': typeof ConfigurationBasicDataResourceRoute
  '/configuration/customers/new': typeof ConfigurationCustomersNewRoute
  '/configuration/locations/new': typeof ConfigurationLocationsNewRoute
  '/configuration/pharmacies/new': typeof ConfigurationPharmaciesNewRoute
  '/configuration/protocols/new': typeof ConfigurationProtocolsNewRoute
  '/configuration/sections/new': typeof ConfigurationSectionsNewRoute
  '/configuration/smart-compounders/mappings': typeof ConfigurationSmartCompoundersMappingsRoute
  '/configuration/smart-compounders/orders': typeof ConfigurationSmartCompoundersOrdersRoute
  '/configuration/user-groups/new': typeof ConfigurationUserGroupsNewRoute
  '/configuration/users/new': typeof ConfigurationUsersNewRoute
  '/configuration/wards/new': typeof ConfigurationWardsNewRoute
  '/patient-dashboard/patients/$patientId': typeof PatientDashboardPatientsPatientIdRoute
  '/patient-dashboard/patients/new': typeof PatientDashboardPatientsNewRoute
  '/stocks/batches/new': typeof StocksBatchesNewRoute
  '/configuration/customers': typeof ConfigurationCustomersIndexRoute
  '/configuration/hl7': typeof ConfigurationHl7IndexRoute
  '/configuration/locations': typeof ConfigurationLocationsIndexRoute
  '/configuration/pharmacies': typeof ConfigurationPharmaciesIndexRoute
  '/configuration/protocols': typeof ConfigurationProtocolsIndexRoute
  '/configuration/sections': typeof ConfigurationSectionsIndexRoute
  '/configuration/settings': typeof ConfigurationSettingsIndexRoute
  '/configuration/smart-compounders': typeof ConfigurationSmartCompoundersIndexRoute
  '/configuration/system-logs': typeof ConfigurationSystemLogsIndexRoute
  '/configuration/user-groups': typeof ConfigurationUserGroupsIndexRoute
  '/configuration/users': typeof ConfigurationUsersIndexRoute
  '/configuration/wards': typeof ConfigurationWardsIndexRoute
  '/patient-dashboard/patients': typeof PatientDashboardPatientsIndexRoute
  '/stocks/batches': typeof StocksBatchesIndexRoute
  '/stocks/discards': typeof StocksDiscardsIndexRoute
  '/stocks/rest-vials': typeof StocksRestVialsIndexRoute
  '/stocks/returns': typeof StocksReturnsIndexRoute
  '/configuration/basic-data/categories/new': typeof ConfigurationBasicDataCategoriesNewRoute
  '/configuration/drug-catalog/active-substances/new': typeof ConfigurationDrugCatalogActiveSubstancesNewRoute
  '/configuration/drug-catalog/solutions/new': typeof ConfigurationDrugCatalogSolutionsNewRoute
  '/configuration/drug-catalog/supportive-medications/new': typeof ConfigurationDrugCatalogSupportiveMedicationsNewRoute
  '/configuration/products/companies/new': typeof ConfigurationProductsCompaniesNewRoute
  '/configuration/products/consumables/new': typeof ConfigurationProductsConsumablesNewRoute
  '/configuration/products/trade-names/new': typeof ConfigurationProductsTradeNamesNewRoute
  '/configuration/basic-data/categories': typeof ConfigurationBasicDataCategoriesIndexRoute
  '/configuration/drug-catalog/active-substances': typeof ConfigurationDrugCatalogActiveSubstancesIndexRoute
  '/configuration/drug-catalog/solutions': typeof ConfigurationDrugCatalogSolutionsIndexRoute
  '/configuration/drug-catalog/supportive-medications': typeof ConfigurationDrugCatalogSupportiveMedicationsIndexRoute
  '/configuration/products/companies': typeof ConfigurationProductsCompaniesIndexRoute
  '/configuration/products/consumables': typeof ConfigurationProductsConsumablesIndexRoute
  '/configuration/products/trade-names': typeof ConfigurationProductsTradeNamesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activity': typeof ActivityRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/configuration': typeof ConfigurationRouteRouteWithChildren
  '/patient-dashboard': typeof PatientDashboardRouteRouteWithChildren
  '/production': typeof ProductionRouteRouteWithChildren
  '/reports': typeof ReportsRouteRouteWithChildren
  '/stocks': typeof StocksRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/auth/password-setup': typeof AuthPasswordSetupRoute
  '/auth/register': typeof AuthRegisterRoute
  '/activity/': typeof ActivityIndexRoute
  '/cleanroom/': typeof CleanroomIndexRoute
  '/production/': typeof ProductionIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/configuration/basic-data/$resource': typeof ConfigurationBasicDataResourceRoute
  '/configuration/customers/new': typeof ConfigurationCustomersNewRoute
  '/configuration/locations/new': typeof ConfigurationLocationsNewRoute
  '/configuration/pharmacies/new': typeof ConfigurationPharmaciesNewRoute
  '/configuration/protocols/new': typeof ConfigurationProtocolsNewRoute
  '/configuration/sections/new': typeof ConfigurationSectionsNewRoute
  '/configuration/smart-compounders/mappings': typeof ConfigurationSmartCompoundersMappingsRoute
  '/configuration/smart-compounders/orders': typeof ConfigurationSmartCompoundersOrdersRoute
  '/configuration/user-groups/new': typeof ConfigurationUserGroupsNewRoute
  '/configuration/users/new': typeof ConfigurationUsersNewRoute
  '/configuration/wards/new': typeof ConfigurationWardsNewRoute
  '/patient-dashboard/patients/$patientId': typeof PatientDashboardPatientsPatientIdRoute
  '/patient-dashboard/patients/new': typeof PatientDashboardPatientsNewRoute
  '/stocks/batches/new': typeof StocksBatchesNewRoute
  '/configuration/customers/': typeof ConfigurationCustomersIndexRoute
  '/configuration/hl7/': typeof ConfigurationHl7IndexRoute
  '/configuration/locations/': typeof ConfigurationLocationsIndexRoute
  '/configuration/pharmacies/': typeof ConfigurationPharmaciesIndexRoute
  '/configuration/protocols/': typeof ConfigurationProtocolsIndexRoute
  '/configuration/sections/': typeof ConfigurationSectionsIndexRoute
  '/configuration/settings/': typeof ConfigurationSettingsIndexRoute
  '/configuration/smart-compounders/': typeof ConfigurationSmartCompoundersIndexRoute
  '/configuration/system-logs/': typeof ConfigurationSystemLogsIndexRoute
  '/configuration/user-groups/': typeof ConfigurationUserGroupsIndexRoute
  '/configuration/users/': typeof ConfigurationUsersIndexRoute
  '/configuration/wards/': typeof ConfigurationWardsIndexRoute
  '/patient-dashboard/patients/': typeof PatientDashboardPatientsIndexRoute
  '/stocks/batches/': typeof StocksBatchesIndexRoute
  '/stocks/discards/': typeof StocksDiscardsIndexRoute
  '/stocks/rest-vials/': typeof StocksRestVialsIndexRoute
  '/stocks/returns/': typeof StocksReturnsIndexRoute
  '/configuration/basic-data/categories/new': typeof ConfigurationBasicDataCategoriesNewRoute
  '/configuration/drug-catalog/active-substances/new': typeof ConfigurationDrugCatalogActiveSubstancesNewRoute
  '/configuration/drug-catalog/solutions/new': typeof ConfigurationDrugCatalogSolutionsNewRoute
  '/configuration/drug-catalog/supportive-medications/new': typeof ConfigurationDrugCatalogSupportiveMedicationsNewRoute
  '/configuration/products/companies/new': typeof ConfigurationProductsCompaniesNewRoute
  '/configuration/products/consumables/new': typeof ConfigurationProductsConsumablesNewRoute
  '/configuration/products/trade-names/new': typeof ConfigurationProductsTradeNamesNewRoute
  '/configuration/basic-data/categories/': typeof ConfigurationBasicDataCategoriesIndexRoute
  '/configuration/drug-catalog/active-substances/': typeof ConfigurationDrugCatalogActiveSubstancesIndexRoute
  '/configuration/drug-catalog/solutions/': typeof ConfigurationDrugCatalogSolutionsIndexRoute
  '/configuration/drug-catalog/supportive-medications/': typeof ConfigurationDrugCatalogSupportiveMedicationsIndexRoute
  '/configuration/products/companies/': typeof ConfigurationProductsCompaniesIndexRoute
  '/configuration/products/consumables/': typeof ConfigurationProductsConsumablesIndexRoute
  '/configuration/products/trade-names/': typeof ConfigurationProductsTradeNamesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activity'
    | '/auth'
    | '/configuration'
    | '/patient-dashboard'
    | '/production'
    | '/reports'
    | '/stocks'
    | '/auth/login'
    | '/auth/password-setup'
    | '/auth/register'
    | '/activity/'
    | '/cleanroom/'
    | '/production/'
    | '/reports/'
    | '/configuration/basic-data/$resource'
    | '/configuration/customers/new'
    | '/configuration/locations/new'
    | '/configuration/pharmacies/new'
    | '/configuration/protocols/new'
    | '/configuration/sections/new'
    | '/configuration/smart-compounders/mappings'
    | '/configuration/smart-compounders/orders'
    | '/configuration/user-groups/new'
    | '/configuration/users/new'
    | '/configuration/wards/new'
    | '/patient-dashboard/patients/$patientId'
    | '/patient-dashboard/patients/new'
    | '/stocks/batches/new'
    | '/configuration/customers/'
    | '/configuration/hl7/'
    | '/configuration/locations/'
    | '/configuration/pharmacies/'
    | '/configuration/protocols/'
    | '/configuration/sections/'
    | '/configuration/settings/'
    | '/configuration/smart-compounders/'
    | '/configuration/system-logs/'
    | '/configuration/user-groups/'
    | '/configuration/users/'
    | '/configuration/wards/'
    | '/patient-dashboard/patients/'
    | '/stocks/batches/'
    | '/stocks/discards/'
    | '/stocks/rest-vials/'
    | '/stocks/returns/'
    | '/configuration/basic-data/categories/new'
    | '/configuration/drug-catalog/active-substances/new'
    | '/configuration/drug-catalog/solutions/new'
    | '/configuration/drug-catalog/supportive-medications/new'
    | '/configuration/products/companies/new'
    | '/configuration/products/consumables/new'
    | '/configuration/products/trade-names/new'
    | '/configuration/basic-data/categories/'
    | '/configuration/drug-catalog/active-substances/'
    | '/configuration/drug-catalog/solutions/'
    | '/configuration/drug-catalog/supportive-medications/'
    | '/configuration/products/companies/'
    | '/configuration/products/consumables/'
    | '/configuration/products/trade-names/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/configuration'
    | '/patient-dashboard'
    | '/stocks'
    | '/auth/login'
    | '/auth/password-setup'
    | '/auth/register'
    | '/activity'
    | '/cleanroom'
    | '/production'
    | '/reports'
    | '/configuration/basic-data/$resource'
    | '/configuration/customers/new'
    | '/configuration/locations/new'
    | '/configuration/pharmacies/new'
    | '/configuration/protocols/new'
    | '/configuration/sections/new'
    | '/configuration/smart-compounders/mappings'
    | '/configuration/smart-compounders/orders'
    | '/configuration/user-groups/new'
    | '/configuration/users/new'
    | '/configuration/wards/new'
    | '/patient-dashboard/patients/$patientId'
    | '/patient-dashboard/patients/new'
    | '/stocks/batches/new'
    | '/configuration/customers'
    | '/configuration/hl7'
    | '/configuration/locations'
    | '/configuration/pharmacies'
    | '/configuration/protocols'
    | '/configuration/sections'
    | '/configuration/settings'
    | '/configuration/smart-compounders'
    | '/configuration/system-logs'
    | '/configuration/user-groups'
    | '/configuration/users'
    | '/configuration/wards'
    | '/patient-dashboard/patients'
    | '/stocks/batches'
    | '/stocks/discards'
    | '/stocks/rest-vials'
    | '/stocks/returns'
    | '/configuration/basic-data/categories/new'
    | '/configuration/drug-catalog/active-substances/new'
    | '/configuration/drug-catalog/solutions/new'
    | '/configuration/drug-catalog/supportive-medications/new'
    | '/configuration/products/companies/new'
    | '/configuration/products/consumables/new'
    | '/configuration/products/trade-names/new'
    | '/configuration/basic-data/categories'
    | '/configuration/drug-catalog/active-substances'
    | '/configuration/drug-catalog/solutions'
    | '/configuration/drug-catalog/supportive-medications'
    | '/configuration/products/companies'
    | '/configuration/products/consumables'
    | '/configuration/products/trade-names'
  id:
    | '__root__'
    | '/'
    | '/activity'
    | '/auth'
    | '/configuration'
    | '/patient-dashboard'
    | '/production'
    | '/reports'
    | '/stocks'
    | '/auth/login'
    | '/auth/password-setup'
    | '/auth/register'
    | '/activity/'
    | '/cleanroom/'
    | '/production/'
    | '/reports/'
    | '/configuration/basic-data/$resource'
    | '/configuration/customers/new'
    | '/configuration/locations/new'
    | '/configuration/pharmacies/new'
    | '/configuration/protocols/new'
    | '/configuration/sections/new'
    | '/configuration/smart-compounders/mappings'
    | '/configuration/smart-compounders/orders'
    | '/configuration/user-groups/new'
    | '/configuration/users/new'
    | '/configuration/wards/new'
    | '/patient-dashboard/patients/$patientId'
    | '/patient-dashboard/patients/new'
    | '/stocks/batches/new'
    | '/configuration/customers/'
    | '/configuration/hl7/'
    | '/configuration/locations/'
    | '/configuration/pharmacies/'
    | '/configuration/protocols/'
    | '/configuration/sections/'
    | '/configuration/settings/'
    | '/configuration/smart-compounders/'
    | '/configuration/system-logs/'
    | '/configuration/user-groups/'
    | '/configuration/users/'
    | '/configuration/wards/'
    | '/patient-dashboard/patients/'
    | '/stocks/batches/'
    | '/stocks/discards/'
    | '/stocks/rest-vials/'
    | '/stocks/returns/'
    | '/configuration/basic-data/categories/new'
    | '/configuration/drug-catalog/active-substances/new'
    | '/configuration/drug-catalog/solutions/new'
    | '/configuration/drug-catalog/supportive-medications/new'
    | '/configuration/products/companies/new'
    | '/configuration/products/consumables/new'
    | '/configuration/products/trade-names/new'
    | '/configuration/basic-data/categories/'
    | '/configuration/drug-catalog/active-substances/'
    | '/configuration/drug-catalog/solutions/'
    | '/configuration/drug-catalog/supportive-medications/'
    | '/configuration/products/companies/'
    | '/configuration/products/consumables/'
    | '/configuration/products/trade-names/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivityRouteRoute: typeof ActivityRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  ConfigurationRouteRoute: typeof ConfigurationRouteRouteWithChildren
  PatientDashboardRouteRoute: typeof PatientDashboardRouteRouteWithChildren
  ProductionRouteRoute: typeof ProductionRouteRouteWithChildren
  ReportsRouteRoute: typeof ReportsRouteRouteWithChildren
  StocksRouteRoute: typeof StocksRouteRouteWithChildren
  CleanroomIndexRoute: typeof CleanroomIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/stocks': {
      id: '/stocks'
      path: '/stocks'
      fullPath: '/stocks'
      preLoaderRoute: typeof StocksRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/production': {
      id: '/production'
      path: '/production'
      fullPath: '/production'
      preLoaderRoute: typeof ProductionRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patient-dashboard': {
      id: '/patient-dashboard'
      path: '/patient-dashboard'
      fullPath: '/patient-dashboard'
      preLoaderRoute: typeof PatientDashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration': {
      id: '/configuration'
      path: '/configuration'
      fullPath: '/configuration'
      preLoaderRoute: typeof ConfigurationRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof ReportsRouteRoute
    }
    '/production/': {
      id: '/production/'
      path: '/'
      fullPath: '/production/'
      preLoaderRoute: typeof ProductionIndexRouteImport
      parentRoute: typeof ProductionRouteRoute
    }
    '/cleanroom/': {
      id: '/cleanroom/'
      path: '/cleanroom'
      fullPath: '/cleanroom/'
      preLoaderRoute: typeof CleanroomIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity/': {
      id: '/activity/'
      path: '/'
      fullPath: '/activity/'
      preLoaderRoute: typeof ActivityIndexRouteImport
      parentRoute: typeof ActivityRouteRoute
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/password-setup': {
      id: '/auth/password-setup'
      path: '/password-setup'
      fullPath: '/auth/password-setup'
      preLoaderRoute: typeof AuthPasswordSetupRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/stocks/returns/': {
      id: '/stocks/returns/'
      path: '/returns'
      fullPath: '/stocks/returns/'
      preLoaderRoute: typeof StocksReturnsIndexRouteImport
      parentRoute: typeof StocksRouteRoute
    }
    '/stocks/rest-vials/': {
      id: '/stocks/rest-vials/'
      path: '/rest-vials'
      fullPath: '/stocks/rest-vials/'
      preLoaderRoute: typeof StocksRestVialsIndexRouteImport
      parentRoute: typeof StocksRouteRoute
    }
    '/stocks/discards/': {
      id: '/stocks/discards/'
      path: '/discards'
      fullPath: '/stocks/discards/'
      preLoaderRoute: typeof StocksDiscardsIndexRouteImport
      parentRoute: typeof StocksRouteRoute
    }
    '/stocks/batches/': {
      id: '/stocks/batches/'
      path: '/batches'
      fullPath: '/stocks/batches/'
      preLoaderRoute: typeof StocksBatchesIndexRouteImport
      parentRoute: typeof StocksRouteRoute
    }
    '/patient-dashboard/patients/': {
      id: '/patient-dashboard/patients/'
      path: '/patients'
      fullPath: '/patient-dashboard/patients/'
      preLoaderRoute: typeof PatientDashboardPatientsIndexRouteImport
      parentRoute: typeof PatientDashboardRouteRoute
    }
    '/configuration/wards/': {
      id: '/configuration/wards/'
      path: '/wards'
      fullPath: '/configuration/wards/'
      preLoaderRoute: typeof ConfigurationWardsIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/users/': {
      id: '/configuration/users/'
      path: '/users'
      fullPath: '/configuration/users/'
      preLoaderRoute: typeof ConfigurationUsersIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/user-groups/': {
      id: '/configuration/user-groups/'
      path: '/user-groups'
      fullPath: '/configuration/user-groups/'
      preLoaderRoute: typeof ConfigurationUserGroupsIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/system-logs/': {
      id: '/configuration/system-logs/'
      path: '/system-logs'
      fullPath: '/configuration/system-logs/'
      preLoaderRoute: typeof ConfigurationSystemLogsIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/smart-compounders/': {
      id: '/configuration/smart-compounders/'
      path: '/smart-compounders'
      fullPath: '/configuration/smart-compounders/'
      preLoaderRoute: typeof ConfigurationSmartCompoundersIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/settings/': {
      id: '/configuration/settings/'
      path: '/settings'
      fullPath: '/configuration/settings/'
      preLoaderRoute: typeof ConfigurationSettingsIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/sections/': {
      id: '/configuration/sections/'
      path: '/sections'
      fullPath: '/configuration/sections/'
      preLoaderRoute: typeof ConfigurationSectionsIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/protocols/': {
      id: '/configuration/protocols/'
      path: '/protocols'
      fullPath: '/configuration/protocols/'
      preLoaderRoute: typeof ConfigurationProtocolsIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/pharmacies/': {
      id: '/configuration/pharmacies/'
      path: '/pharmacies'
      fullPath: '/configuration/pharmacies/'
      preLoaderRoute: typeof ConfigurationPharmaciesIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/locations/': {
      id: '/configuration/locations/'
      path: '/locations'
      fullPath: '/configuration/locations/'
      preLoaderRoute: typeof ConfigurationLocationsIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/hl7/': {
      id: '/configuration/hl7/'
      path: '/hl7'
      fullPath: '/configuration/hl7/'
      preLoaderRoute: typeof ConfigurationHl7IndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/customers/': {
      id: '/configuration/customers/'
      path: '/customers'
      fullPath: '/configuration/customers/'
      preLoaderRoute: typeof ConfigurationCustomersIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/stocks/batches/new': {
      id: '/stocks/batches/new'
      path: '/batches/new'
      fullPath: '/stocks/batches/new'
      preLoaderRoute: typeof StocksBatchesNewRouteImport
      parentRoute: typeof StocksRouteRoute
    }
    '/patient-dashboard/patients/new': {
      id: '/patient-dashboard/patients/new'
      path: '/patients/new'
      fullPath: '/patient-dashboard/patients/new'
      preLoaderRoute: typeof PatientDashboardPatientsNewRouteImport
      parentRoute: typeof PatientDashboardRouteRoute
    }
    '/patient-dashboard/patients/$patientId': {
      id: '/patient-dashboard/patients/$patientId'
      path: '/patients/$patientId'
      fullPath: '/patient-dashboard/patients/$patientId'
      preLoaderRoute: typeof PatientDashboardPatientsPatientIdRouteImport
      parentRoute: typeof PatientDashboardRouteRoute
    }
    '/configuration/wards/new': {
      id: '/configuration/wards/new'
      path: '/wards/new'
      fullPath: '/configuration/wards/new'
      preLoaderRoute: typeof ConfigurationWardsNewRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/users/new': {
      id: '/configuration/users/new'
      path: '/users/new'
      fullPath: '/configuration/users/new'
      preLoaderRoute: typeof ConfigurationUsersNewRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/user-groups/new': {
      id: '/configuration/user-groups/new'
      path: '/user-groups/new'
      fullPath: '/configuration/user-groups/new'
      preLoaderRoute: typeof ConfigurationUserGroupsNewRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/smart-compounders/orders': {
      id: '/configuration/smart-compounders/orders'
      path: '/smart-compounders/orders'
      fullPath: '/configuration/smart-compounders/orders'
      preLoaderRoute: typeof ConfigurationSmartCompoundersOrdersRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/smart-compounders/mappings': {
      id: '/configuration/smart-compounders/mappings'
      path: '/smart-compounders/mappings'
      fullPath: '/configuration/smart-compounders/mappings'
      preLoaderRoute: typeof ConfigurationSmartCompoundersMappingsRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/sections/new': {
      id: '/configuration/sections/new'
      path: '/sections/new'
      fullPath: '/configuration/sections/new'
      preLoaderRoute: typeof ConfigurationSectionsNewRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/protocols/new': {
      id: '/configuration/protocols/new'
      path: '/protocols/new'
      fullPath: '/configuration/protocols/new'
      preLoaderRoute: typeof ConfigurationProtocolsNewRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/pharmacies/new': {
      id: '/configuration/pharmacies/new'
      path: '/pharmacies/new'
      fullPath: '/configuration/pharmacies/new'
      preLoaderRoute: typeof ConfigurationPharmaciesNewRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/locations/new': {
      id: '/configuration/locations/new'
      path: '/locations/new'
      fullPath: '/configuration/locations/new'
      preLoaderRoute: typeof ConfigurationLocationsNewRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/customers/new': {
      id: '/configuration/customers/new'
      path: '/customers/new'
      fullPath: '/configuration/customers/new'
      preLoaderRoute: typeof ConfigurationCustomersNewRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/basic-data/$resource': {
      id: '/configuration/basic-data/$resource'
      path: '/basic-data/$resource'
      fullPath: '/configuration/basic-data/$resource'
      preLoaderRoute: typeof ConfigurationBasicDataResourceRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/products/trade-names/': {
      id: '/configuration/products/trade-names/'
      path: '/products/trade-names'
      fullPath: '/configuration/products/trade-names/'
      preLoaderRoute: typeof ConfigurationProductsTradeNamesIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/products/consumables/': {
      id: '/configuration/products/consumables/'
      path: '/products/consumables'
      fullPath: '/configuration/products/consumables/'
      preLoaderRoute: typeof ConfigurationProductsConsumablesIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/products/companies/': {
      id: '/configuration/products/companies/'
      path: '/products/companies'
      fullPath: '/configuration/products/companies/'
      preLoaderRoute: typeof ConfigurationProductsCompaniesIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/drug-catalog/supportive-medications/': {
      id: '/configuration/drug-catalog/supportive-medications/'
      path: '/drug-catalog/supportive-medications'
      fullPath: '/configuration/drug-catalog/supportive-medications/'
      preLoaderRoute: typeof ConfigurationDrugCatalogSupportiveMedicationsIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/drug-catalog/solutions/': {
      id: '/configuration/drug-catalog/solutions/'
      path: '/drug-catalog/solutions'
      fullPath: '/configuration/drug-catalog/solutions/'
      preLoaderRoute: typeof ConfigurationDrugCatalogSolutionsIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/drug-catalog/active-substances/': {
      id: '/configuration/drug-catalog/active-substances/'
      path: '/drug-catalog/active-substances'
      fullPath: '/configuration/drug-catalog/active-substances/'
      preLoaderRoute: typeof ConfigurationDrugCatalogActiveSubstancesIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/basic-data/categories/': {
      id: '/configuration/basic-data/categories/'
      path: '/basic-data/categories'
      fullPath: '/configuration/basic-data/categories/'
      preLoaderRoute: typeof ConfigurationBasicDataCategoriesIndexRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/products/trade-names/new': {
      id: '/configuration/products/trade-names/new'
      path: '/products/trade-names/new'
      fullPath: '/configuration/products/trade-names/new'
      preLoaderRoute: typeof ConfigurationProductsTradeNamesNewRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/products/consumables/new': {
      id: '/configuration/products/consumables/new'
      path: '/products/consumables/new'
      fullPath: '/configuration/products/consumables/new'
      preLoaderRoute: typeof ConfigurationProductsConsumablesNewRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/products/companies/new': {
      id: '/configuration/products/companies/new'
      path: '/products/companies/new'
      fullPath: '/configuration/products/companies/new'
      preLoaderRoute: typeof ConfigurationProductsCompaniesNewRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/drug-catalog/supportive-medications/new': {
      id: '/configuration/drug-catalog/supportive-medications/new'
      path: '/drug-catalog/supportive-medications/new'
      fullPath: '/configuration/drug-catalog/supportive-medications/new'
      preLoaderRoute: typeof ConfigurationDrugCatalogSupportiveMedicationsNewRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/drug-catalog/solutions/new': {
      id: '/configuration/drug-catalog/solutions/new'
      path: '/drug-catalog/solutions/new'
      fullPath: '/configuration/drug-catalog/solutions/new'
      preLoaderRoute: typeof ConfigurationDrugCatalogSolutionsNewRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/drug-catalog/active-substances/new': {
      id: '/configuration/drug-catalog/active-substances/new'
      path: '/drug-catalog/active-substances/new'
      fullPath: '/configuration/drug-catalog/active-substances/new'
      preLoaderRoute: typeof ConfigurationDrugCatalogActiveSubstancesNewRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
    '/configuration/basic-data/categories/new': {
      id: '/configuration/basic-data/categories/new'
      path: '/basic-data/categories/new'
      fullPath: '/configuration/basic-data/categories/new'
      preLoaderRoute: typeof ConfigurationBasicDataCategoriesNewRouteImport
      parentRoute: typeof ConfigurationRouteRoute
    }
  }
}

interface ActivityRouteRouteChildren {
  ActivityIndexRoute: typeof ActivityIndexRoute
}

const ActivityRouteRouteChildren: ActivityRouteRouteChildren = {
  ActivityIndexRoute: ActivityIndexRoute,
}

const ActivityRouteRouteWithChildren = ActivityRouteRoute._addFileChildren(
  ActivityRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthPasswordSetupRoute: typeof AuthPasswordSetupRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthPasswordSetupRoute: AuthPasswordSetupRoute,
  AuthRegisterRoute: AuthRegisterRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface ConfigurationRouteRouteChildren {
  ConfigurationBasicDataResourceRoute: typeof ConfigurationBasicDataResourceRoute
  ConfigurationCustomersNewRoute: typeof ConfigurationCustomersNewRoute
  ConfigurationLocationsNewRoute: typeof ConfigurationLocationsNewRoute
  ConfigurationPharmaciesNewRoute: typeof ConfigurationPharmaciesNewRoute
  ConfigurationProtocolsNewRoute: typeof ConfigurationProtocolsNewRoute
  ConfigurationSectionsNewRoute: typeof ConfigurationSectionsNewRoute
  ConfigurationSmartCompoundersMappingsRoute: typeof ConfigurationSmartCompoundersMappingsRoute
  ConfigurationSmartCompoundersOrdersRoute: typeof ConfigurationSmartCompoundersOrdersRoute
  ConfigurationUserGroupsNewRoute: typeof ConfigurationUserGroupsNewRoute
  ConfigurationUsersNewRoute: typeof ConfigurationUsersNewRoute
  ConfigurationWardsNewRoute: typeof ConfigurationWardsNewRoute
  ConfigurationCustomersIndexRoute: typeof ConfigurationCustomersIndexRoute
  ConfigurationHl7IndexRoute: typeof ConfigurationHl7IndexRoute
  ConfigurationLocationsIndexRoute: typeof ConfigurationLocationsIndexRoute
  ConfigurationPharmaciesIndexRoute: typeof ConfigurationPharmaciesIndexRoute
  ConfigurationProtocolsIndexRoute: typeof ConfigurationProtocolsIndexRoute
  ConfigurationSectionsIndexRoute: typeof ConfigurationSectionsIndexRoute
  ConfigurationSettingsIndexRoute: typeof ConfigurationSettingsIndexRoute
  ConfigurationSmartCompoundersIndexRoute: typeof ConfigurationSmartCompoundersIndexRoute
  ConfigurationSystemLogsIndexRoute: typeof ConfigurationSystemLogsIndexRoute
  ConfigurationUserGroupsIndexRoute: typeof ConfigurationUserGroupsIndexRoute
  ConfigurationUsersIndexRoute: typeof ConfigurationUsersIndexRoute
  ConfigurationWardsIndexRoute: typeof ConfigurationWardsIndexRoute
  ConfigurationBasicDataCategoriesNewRoute: typeof ConfigurationBasicDataCategoriesNewRoute
  ConfigurationDrugCatalogActiveSubstancesNewRoute: typeof ConfigurationDrugCatalogActiveSubstancesNewRoute
  ConfigurationDrugCatalogSolutionsNewRoute: typeof ConfigurationDrugCatalogSolutionsNewRoute
  ConfigurationDrugCatalogSupportiveMedicationsNewRoute: typeof ConfigurationDrugCatalogSupportiveMedicationsNewRoute
  ConfigurationProductsCompaniesNewRoute: typeof ConfigurationProductsCompaniesNewRoute
  ConfigurationProductsConsumablesNewRoute: typeof ConfigurationProductsConsumablesNewRoute
  ConfigurationProductsTradeNamesNewRoute: typeof ConfigurationProductsTradeNamesNewRoute
  ConfigurationBasicDataCategoriesIndexRoute: typeof ConfigurationBasicDataCategoriesIndexRoute
  ConfigurationDrugCatalogActiveSubstancesIndexRoute: typeof ConfigurationDrugCatalogActiveSubstancesIndexRoute
  ConfigurationDrugCatalogSolutionsIndexRoute: typeof ConfigurationDrugCatalogSolutionsIndexRoute
  ConfigurationDrugCatalogSupportiveMedicationsIndexRoute: typeof ConfigurationDrugCatalogSupportiveMedicationsIndexRoute
  ConfigurationProductsCompaniesIndexRoute: typeof ConfigurationProductsCompaniesIndexRoute
  ConfigurationProductsConsumablesIndexRoute: typeof ConfigurationProductsConsumablesIndexRoute
  ConfigurationProductsTradeNamesIndexRoute: typeof ConfigurationProductsTradeNamesIndexRoute
}

const ConfigurationRouteRouteChildren: ConfigurationRouteRouteChildren = {
  ConfigurationBasicDataResourceRoute: ConfigurationBasicDataResourceRoute,
  ConfigurationCustomersNewRoute: ConfigurationCustomersNewRoute,
  ConfigurationLocationsNewRoute: ConfigurationLocationsNewRoute,
  ConfigurationPharmaciesNewRoute: ConfigurationPharmaciesNewRoute,
  ConfigurationProtocolsNewRoute: ConfigurationProtocolsNewRoute,
  ConfigurationSectionsNewRoute: ConfigurationSectionsNewRoute,
  ConfigurationSmartCompoundersMappingsRoute:
    ConfigurationSmartCompoundersMappingsRoute,
  ConfigurationSmartCompoundersOrdersRoute:
    ConfigurationSmartCompoundersOrdersRoute,
  ConfigurationUserGroupsNewRoute: ConfigurationUserGroupsNewRoute,
  ConfigurationUsersNewRoute: ConfigurationUsersNewRoute,
  ConfigurationWardsNewRoute: ConfigurationWardsNewRoute,
  ConfigurationCustomersIndexRoute: ConfigurationCustomersIndexRoute,
  ConfigurationHl7IndexRoute: ConfigurationHl7IndexRoute,
  ConfigurationLocationsIndexRoute: ConfigurationLocationsIndexRoute,
  ConfigurationPharmaciesIndexRoute: ConfigurationPharmaciesIndexRoute,
  ConfigurationProtocolsIndexRoute: ConfigurationProtocolsIndexRoute,
  ConfigurationSectionsIndexRoute: ConfigurationSectionsIndexRoute,
  ConfigurationSettingsIndexRoute: ConfigurationSettingsIndexRoute,
  ConfigurationSmartCompoundersIndexRoute:
    ConfigurationSmartCompoundersIndexRoute,
  ConfigurationSystemLogsIndexRoute: ConfigurationSystemLogsIndexRoute,
  ConfigurationUserGroupsIndexRoute: ConfigurationUserGroupsIndexRoute,
  ConfigurationUsersIndexRoute: ConfigurationUsersIndexRoute,
  ConfigurationWardsIndexRoute: ConfigurationWardsIndexRoute,
  ConfigurationBasicDataCategoriesNewRoute:
    ConfigurationBasicDataCategoriesNewRoute,
  ConfigurationDrugCatalogActiveSubstancesNewRoute:
    ConfigurationDrugCatalogActiveSubstancesNewRoute,
  ConfigurationDrugCatalogSolutionsNewRoute:
    ConfigurationDrugCatalogSolutionsNewRoute,
  ConfigurationDrugCatalogSupportiveMedicationsNewRoute:
    ConfigurationDrugCatalogSupportiveMedicationsNewRoute,
  ConfigurationProductsCompaniesNewRoute:
    ConfigurationProductsCompaniesNewRoute,
  ConfigurationProductsConsumablesNewRoute:
    ConfigurationProductsConsumablesNewRoute,
  ConfigurationProductsTradeNamesNewRoute:
    ConfigurationProductsTradeNamesNewRoute,
  ConfigurationBasicDataCategoriesIndexRoute:
    ConfigurationBasicDataCategoriesIndexRoute,
  ConfigurationDrugCatalogActiveSubstancesIndexRoute:
    ConfigurationDrugCatalogActiveSubstancesIndexRoute,
  ConfigurationDrugCatalogSolutionsIndexRoute:
    ConfigurationDrugCatalogSolutionsIndexRoute,
  ConfigurationDrugCatalogSupportiveMedicationsIndexRoute:
    ConfigurationDrugCatalogSupportiveMedicationsIndexRoute,
  ConfigurationProductsCompaniesIndexRoute:
    ConfigurationProductsCompaniesIndexRoute,
  ConfigurationProductsConsumablesIndexRoute:
    ConfigurationProductsConsumablesIndexRoute,
  ConfigurationProductsTradeNamesIndexRoute:
    ConfigurationProductsTradeNamesIndexRoute,
}

const ConfigurationRouteRouteWithChildren =
  ConfigurationRouteRoute._addFileChildren(ConfigurationRouteRouteChildren)

interface PatientDashboardRouteRouteChildren {
  PatientDashboardPatientsPatientIdRoute: typeof PatientDashboardPatientsPatientIdRoute
  PatientDashboardPatientsNewRoute: typeof PatientDashboardPatientsNewRoute
  PatientDashboardPatientsIndexRoute: typeof PatientDashboardPatientsIndexRoute
}

const PatientDashboardRouteRouteChildren: PatientDashboardRouteRouteChildren = {
  PatientDashboardPatientsPatientIdRoute:
    PatientDashboardPatientsPatientIdRoute,
  PatientDashboardPatientsNewRoute: PatientDashboardPatientsNewRoute,
  PatientDashboardPatientsIndexRoute: PatientDashboardPatientsIndexRoute,
}

const PatientDashboardRouteRouteWithChildren =
  PatientDashboardRouteRoute._addFileChildren(
    PatientDashboardRouteRouteChildren,
  )

interface ProductionRouteRouteChildren {
  ProductionIndexRoute: typeof ProductionIndexRoute
}

const ProductionRouteRouteChildren: ProductionRouteRouteChildren = {
  ProductionIndexRoute: ProductionIndexRoute,
}

const ProductionRouteRouteWithChildren = ProductionRouteRoute._addFileChildren(
  ProductionRouteRouteChildren,
)

interface ReportsRouteRouteChildren {
  ReportsIndexRoute: typeof ReportsIndexRoute
}

const ReportsRouteRouteChildren: ReportsRouteRouteChildren = {
  ReportsIndexRoute: ReportsIndexRoute,
}

const ReportsRouteRouteWithChildren = ReportsRouteRoute._addFileChildren(
  ReportsRouteRouteChildren,
)

interface StocksRouteRouteChildren {
  StocksBatchesNewRoute: typeof StocksBatchesNewRoute
  StocksBatchesIndexRoute: typeof StocksBatchesIndexRoute
  StocksDiscardsIndexRoute: typeof StocksDiscardsIndexRoute
  StocksRestVialsIndexRoute: typeof StocksRestVialsIndexRoute
  StocksReturnsIndexRoute: typeof StocksReturnsIndexRoute
}

const StocksRouteRouteChildren: StocksRouteRouteChildren = {
  StocksBatchesNewRoute: StocksBatchesNewRoute,
  StocksBatchesIndexRoute: StocksBatchesIndexRoute,
  StocksDiscardsIndexRoute: StocksDiscardsIndexRoute,
  StocksRestVialsIndexRoute: StocksRestVialsIndexRoute,
  StocksReturnsIndexRoute: StocksReturnsIndexRoute,
}

const StocksRouteRouteWithChildren = StocksRouteRoute._addFileChildren(
  StocksRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivityRouteRoute: ActivityRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  ConfigurationRouteRoute: ConfigurationRouteRouteWithChildren,
  PatientDashboardRouteRoute: PatientDashboardRouteRouteWithChildren,
  ProductionRouteRoute: ProductionRouteRouteWithChildren,
  ReportsRouteRoute: ReportsRouteRouteWithChildren,
  StocksRouteRoute: StocksRouteRouteWithChildren,
  CleanroomIndexRoute: CleanroomIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
